import { useState } from "react";

import Form from "../../../components/Form";
import Joi from "joi-browser";
import { message } from "antd";
import {
  addContactAttributesIfPresent,
  fieldSchema,
  fieldTemplates,
  fieldValues,
} from "./common/contactFields";
import { toNumberField, triggerTypeField } from "V2.0/HomePages/Campaigns/common/fields";
import { showErrorToast } from "V2.0/utils"

export function Sms(props) {
  const {
    addUserToCampaign,
    onClose,
    assistantId,
    fromNumber,
    ignorePreviousCampaigns,
  } = props;
  const [loading, setLoading] = useState(false);

  const inputField = {
    ...fieldValues,
    toNumber: "",
    fromNumber,
    triggerType: "",
    message: "",
    campaignType: "sms",
    assistantId,
    ignorePreviousCampaigns,
  };

  const [errorMessage] = useState({});

  const template = [
    ...fieldTemplates,
    toNumberField,
    triggerTypeField,
    {
      name: "message",
      label: "Message",
      description: "The message to be sent to your contact",
      type: "textArea",
      style: { height: "100px" },
    },
  ];

  const schema = {
    ...fieldSchema,
    message: Joi.string().required().max(160).label("message"),
    toNumber: Joi.string()
      .regex(/^\+?[0-9]+$/)
      .required()
      .label("To Number"),
    fromNumber: Joi.string()
      .regex(/^\+?[0-9]+$/)
      .required()
      .label("From Number"),
    triggerType: Joi.string().required().label("Trigger Type"),
    campaignType: Joi.string().required().label("Campaign Type"),
    assistantId: Joi.string().required(),
    ignorePreviousCampaigns: Joi.boolean(),
  };

  const handleSubmit = (data) => {
    const { firstName, lastName, email, ...rest } = data;
    const payload = {
      ...rest,
      ...addContactAttributesIfPresent(data),
    };
    addUserToCampaign(
      payload,
      (response) => {
        if (response.status === 200) {
          message.success("Success");
          onClose();
          setLoading(false);
        }
      },
      (e) => {
        showErrorToast(e, "Failed to create campaign");
        setLoading(false);
        onClose();
      }
    );
  };

  return (
    <Form
      key={JSON.stringify(inputField)}
      errorMessage={errorMessage}
      inputField={inputField}
      template={template}
      schema={schema}
      buttonInfo={{
        style: "",
        buttons: "2",
        primaryLabel: "Start",
        secondaryLabel: "Close",
      }}
      onSubmit={handleSubmit}
      loading={loading}
      setLoading={setLoading}
      handleSecondary={onClose}
    />
  );
}
